import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISidebarGroupContentProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useSidebarRootContext
} from "../../context";

const SidebarGroupContent: FC<ISidebarGroupContentProps> = ({
    customTheme: customThemeProp,
    children,
    style,
    ...props
}) => {
    const root = useSidebarRootContext({
        part: "Sidebar.GroupContent"
    });

    const customTheme = customThemeProp ?? root?.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children}
    </View>;
};
export default SidebarGroupContent;
